import type { PluginImplementType } from './types';

export const definePlugin = (options: PluginImplementType<any, any>) => {
  return options;
};
